



















import { Component, Vue, Prop } from "vue-property-decorator";
import axios, { resHandle } from "@/plugins/axios";
import Translate from "./translate-cmp.vue";
@Component({
  components: {
    Translate
  }
})
export default class DigReportDetail extends Vue {
  private reportId: any = "";
  private report: any = {};
  /**
   * @description 获取报告
   */
  private fetchReport() {
    const params: any = {
      params: {
        report_id: this.reportId
      }
    };
    axios.get("api/wajue/report", params).then(({ data }) => {
      resHandle(this, data).then(() => {
        this.report = data.data;
      });
    });
  }
  /**
   * @description 初始化
   */
  private mounted() {
    this.reportId = this.$route.params.report_id;
    this.fetchReport();
  }
}
